<div class="no-results">
    <img [src]="profileImagePath" alt="No Results Found" class="no-results-image" />
    <p class="no-results-label">{{noRecordFound}}</p>
    <p class="no-results-description">Request a quote, and our sales team will give you a personalized
      rate.</p>
      <up-button class="button-opacity" button-style="outlined" (click)="openExternalScreen()">REQUEST A QUOTE
    </up-button>
  </div>